<ng-container *ngIf="countryToShow">
  <ng-container [ngTemplateOutlet]="countryToShow.templateRef"> </ng-container>
</ng-container>
